import { HouseholdTrackingProgress as ProgressModel } from "../../models/pageModels/HouseholdTracking";
import Loader from "../UI/Loader";
import "./HouseholdTracking.css";

interface HouseholdTrackingProgressProps {
    progress: ProgressModel;
}

const HouseholdTrackingProgress = ({ progress }: HouseholdTrackingProgressProps) => {
    const percentage = progress.total === 0
        ? 0
        : Math.round((progress.completed / progress.total) * 100);
    const activeCopy = progress.activeName
        ? progress.activeStatus === 'retrying'
            ? `Retrying ${progress.activeName}, attempt ${progress.activeAttempt} of 4`
            : `Submitting form for ${progress.activeName}`
        : 'Preparing submissions...';

    return (
        <div id="household-tracking-progress" className="household-tracking-card margin-top-4" aria-live="polite">
            <div className="row align-items-center justify-content-between">
                <div className="column">
                    <h4>Submitting Household Forms</h4>
                    <div>{activeCopy}</div>
                </div>
                <div className="column-auto">
                    <strong>{percentage}%</strong>
                </div>
            </div>
            <div
                className="household-tracking-progress-bar margin-top-3"
                role="progressbar"
                aria-valuemin={0}
                aria-valuemax={progress.total}
                aria-valuenow={progress.completed}>
                <div className="household-tracking-progress-fill" style={{ width: `${percentage}%` }} />
            </div>
            <div className="row align-items-center margin-top-3">
                <div className="column-auto">
                    <Loader noMarginTop={true} />
                </div>
                <div className="column-auto">
                    {progress.completed} of {progress.total} eligible participants completed
                </div>
            </div>
        </div>
    );
};

export default HouseholdTrackingProgress;
